module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/orangeLeftBottomBg-5ceca82fa18389c0a699a1cdfbd873e5.png";